import { createStyles, Card, TextInput, Text, Stack, Divider, Tabs, Group, Button, LoadingOverlay } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useEffect, useState } from 'react';
import * as Realm from "realm-web";
import { useNavigate, useParams } from 'react-router-dom';
import { Select } from '@mantine/core';
import { useBranches } from '../hooks/useBranches';
import { DropzoneButton } from '../components/DropZoneButton';
import { useListState } from '@mantine/hooks';
import { DndListHandle } from '../components/DndListHandle';


const useStyles = createStyles((theme) => ({
  card: {
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
  },
  title: {
    lineHeight: 1,
  },
}));

export function BranchEdit() {
  let { id } = useParams();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const { save, getById, del } = useBranches();
  const [state, handlers] = useListState([]);
  const [edit, setEdit] = useState(false);

  const form = useForm({
    initialValues: {
      name: '',
      phone: '',
      timetable: 'normal',
      address_name: '',
      image: '',
      status: '1',
      _partition: 'PUBLIC',
      map: '',
      address: ''
    },
  });

  useEffect(() => {
    getById(id).then(exh => {
      if(exh) setEdit(true);
      form.setValues(exh);
      if(exh && exh.image) handlers.setState([exh.image])
    });
  }, [id])

  const addNewHall = async (values) => {
    setVisible(true);
    await save(
      {
        ...values, 
        _id: new Realm.BSON.ObjectID(),
        phone: new Realm.BSON.Double(values.phone),
        image: state.length ? state[0] : ''
      }
    )
    navigate('/branches');
  }

  const deleteBranch = () => {
    del(id);
    navigate('/branches');
  }


  return (
    <div style={{position: 'relative'}}>
    <Card withBorder radius="md" p="xl" className={classes.card}>
      <form onSubmit={form.onSubmit(addNewHall)}>

      <LoadingOverlay visible={visible} overlayBlur={2} />

      <Text size="xl" className={classes.title} weight={'bold'}>
        Салбар нэмэх
      </Text>
      <Divider my="sm" />
      <Stack>
        { state.length > 0 && <DndListHandle state={state} handlers={handlers} /> }
        <DropzoneButton state={state} handlers={handlers}/>

        <TextInput
          placeholder="Салбарын нэр"
          label="Салбарын нэр"
          withAsterisk
          {...form.getInputProps('name')}
        />

        <TextInput
          placeholder="Утас"
          type="number"
          label="Утас"
          withAsterisk
          {...form.getInputProps('phone')}
        />

        <TextInput
          placeholder="Google map"
          label="Google map"
          withAsterisk
          {...form.getInputProps('map')}
        />

        <TextInput
          placeholder="Хаяг"
          label="Хаяг"
          withAsterisk
          {...form.getInputProps('address_name')}
        />

        <Divider my="sm" />

        <Button type='submit'>
          Хадгалах
        </Button>

       {edit && <Button color="red" onClick={deleteBranch}> 
          Устгах
        </Button>}

      </Stack>
    </form>
    </Card>
    </div>
  );
}